module.exports = __webpack_public_path__ + "img/img17.f01b9fde.png";